import { EU_COUNTRY_CODES } from '../../constants';

export const isEUMemberAccess = state => {
  const {
    geolocation: { countryCode },
  } = state;

  return EU_COUNTRY_CODES.includes(countryCode);
};

export const getCountryCode = state => {
  const { geolocation: { countryCode = null } = {} } = state;

  return countryCode;
};
